import React, { memo } from "react";
import PropTypes from "prop-types";
import Row from "../../common/Row";
import Button from "../../common/Button";
import Table from "../../common/Table";
import { Popup } from 'semantic-ui-react';

const LinkOrganisatieForm = (props) => {
	const {
		searchModel,
		sportclubs,
		totalSearchResult,
		onOpenModal,
		onCreateNew
	} = props;

	function getCellColorContains(parameter, value) {
		if (value.toLowerCase().includes(parameter.toLowerCase())) {
			return "#009639";
		}
		else {
			return "#e6332a";
		}
	}

	function getCellColorEquals(parameter, value) {
		if (!parameter) {
			return "#777777";
		}
		else if (value && parameter.toLowerCase() === value.toLowerCase()) {
			return "#009639";
		}
		else {
			return "#e6332a";
		}
	}

	function returnCellContent(text, chars) {
		return text && text.length > chars ? <Popup wide="very" position="top left" trigger={<p>{text.substring(0, chars) + "..."}</p>} content={text} /> : text;
	}

	function returnRowIcon(club) {
		return (
			club.isLinkedToFederation || club.isRequestedByFederation ?
				<Popup content={club.isRequestedByFederation ? "Er is reeds een aanvraag gedaan om deze sportclub lid te maken van jouw sportfederatie." : "Deze sportclub is reeds lid van jouw sportfederatie."} trigger={<i className="fa fa-ban" style={{ color: "black", margin: "5px", top: "calc(50%)" }} />} position="left center" />
				:
				<Popup content="Deze sportclub aanmelden als nieuw lid van jouw sportfederatie." trigger={<i className="fa fa-link" style={{ color: "black", margin: "5px", cursor: "pointer", top: "calc(50%)" }} onClick={handleOnOpenModal(club)} />} position="left center" />
		);
	}

	function handleOnOpenModal(sportclub) {
		return function (event) {
			onOpenModal(sportclub, event);
		};
	}

	const rows = sportclubs.map((club, i) => {
		return (
			<tr style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '100%' }} key={i} height="80">
				<td>{returnRowIcon(club)}</td>
				<td style={{ padding: "2px 5px", color: getCellColorContains(searchModel.naam, club.naam), position: "relative" }}>{returnCellContent(club.naam, 15)}</td>
				<td style={{ padding: "2px 5px", color: getCellColorEquals(searchModel.afkorting, club.afkorting) }}>{club.afkorting}</td>
				<td style={{ padding: "2px 5px", color: getCellColorEquals(searchModel.gemeente, club.gemeente) }}>{returnCellContent(club.gemeente, 25)}</td>
				<td style={{ padding: "2px 5px", color: getCellColorEquals(searchModel.ondernemingsnummer, club.ondernemingsnummer) }}>{club.ondernemingsnummer}</td>
				<td style={{ padding: "2px 5px", color: getCellColorEquals(searchModel.telefoon, club.telefoon), whiteSpace: "nowrap" }}>{club.telefoon}</td>
				<td style={{ padding: "2px 5px", color: getCellColorEquals(searchModel.email, club.email) }}>{returnCellContent(club.email, 15)}</td>
				<td style={{ padding: "2px 5px", color: getCellColorEquals(searchModel.website, club.website) }}>{returnCellContent(club.website, 15)}</td>
				<td style={{ padding: "2px 5px", color: "#777777" }}>{returnCellContent(club.actief ? "Actief" : "Inactief", 15)}</td>
			</tr>
		);
	});

	return (
		<div>
			{totalSearchResult > 0 ?
				<div>
					<p style={{ margin: "15px 0" }}>Er werden gelijkaardige organisaties in de databank gevonden. Ben je zeker dat de nieuwe sportclub niet in de databank aanwezig is? Bevestig dat je een nieuwe organisatie wenst aan te maken of selecteer één van onderstaande organisaties en pas dan eventueel de gegevens van die organisatie aan.</p>
					<Row><Button onClick={onCreateNew} text="Maak nieuwe sportclub aan" className="c-button--small c-input" /></Row>
					<Table
						headers={["", "Naam", "Afkorting", "Gemeente", "Ondern. Nr", "Telefoon", "E-mail", "Website", "Actief"]}
						headerSizes={[3, 13, 9, 16, 8, 11, 14, 14, 12]}
					>
						{rows}
					</Table>
					{totalSearchResult > 100 ?
						<p style={{ margin: "15px 0" }}>Er werden meer dan 100 zoekresultaten gevonden, de 100 meest relevante resultaten werden getoond.</p>
						: null
					}

				</div>
				: null
			}

			{
				totalSearchResult === 0 ?
					<div>
						<p style={{ margin: "15px 0" }}>Geen sportclubs gevonden die voldoen aan de opgegeven zoekcriteria.</p>
						<Row><Button onClick={onCreateNew} text="Maak nieuwe sportclub aan" className="c-button--small c-input" /></Row>
					</div>
					: null
			}
		</div>
	);
};

LinkOrganisatieForm.propTypes = {
	searchModel: PropTypes.object,
	sportclubs: PropTypes.array,
	totalSearchResult: PropTypes.number,
	onOpenModal: PropTypes.func,
	onCreateNew: PropTypes.func
};

export default memo(LinkOrganisatieForm);
